import { render, staticRenderFns } from "./STextarea.vue?vue&type=template&id=62a6144c&scoped=true&"
import script from "./STextarea.vue?vue&type=script&lang=ts&"
export * from "./STextarea.vue?vue&type=script&lang=ts&"
import style0 from "./STextarea.vue?vue&type=style&index=0&id=62a6144c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a6144c",
  null
  
)

export default component.exports